import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { uploadImage } from '../api/boardNoticeImg.api';

interface IFileState {
  isLoading: boolean;
  error?: AxiosError | string;
}

const initialState: IFileState = {
  isLoading: false,
};

const imageSlicer = createSlice({
  name: 'image',
  initialState,
  reducers: {
    requestStart: (state: IFileState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (
      state: IFileState,
      action: PayloadAction<AxiosError | string>,
    ) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    uploadSuccess: (state: IFileState) => {
      state.isLoading = false;
      state.error = undefined;
    },
  },
});

export const { requestStart, requestFailure, uploadSuccess } =
  imageSlicer.actions;

export default imageSlicer.reducer;

export const doUploadImage =
  (data: any): any =>
  async (dispatch: any) => {
    try {
      dispatch(requestStart());
      const response = await uploadImage(data);
      dispatch(uploadSuccess());
      return response;
    } catch (e: any) {
      dispatch(requestFailure(e.response?.data?.data || e.message));
      return e.response || null;
    }
  };
